import { useState } from 'react'
import { toast } from 'react-toastify'

import { UnitInspection } from '../models'
import { axiosInstance } from '../helpers'

export const useUnitAreaInspection = () => {
    const [unitInspections, setUnitInspections] = useState<UnitInspection[]>([])

    const getUnitInspections = async (
        getUnitInspectionRequest: getUnitInspectionRequest,
    ) => {
        try {
            const response = await axiosInstance.get(
                `inspection/web-unit-area-inspection/`,
                {
                    params: getUnitInspectionRequest.params,
                },
            )

            const data = response.data as UnitInspection[]
            setUnitInspections(data)
            return data
        } catch (error) {
            toast.error('Failed to get unit inspections')
            return Promise.reject(error)
        }
    }
    return {
        unitInspections,
        setUnitInspections,
        getUnitInspections,
    }
}

export interface getUnitInspectionRequest {
    params: {
        unit: number
        area: number
    }
}
